export default __webpack_public_path__ + "static/ACCEPTRARE-3c4b8682077b632626b155a5e78e7f24.png";